import globalReportReducer from "@features/reports/globalReportSlice";
import { combineReducers } from "@reduxjs/toolkit";

import channelReducer from "./slices/channelSlice";
import errorReducer from "./slices/errorSlice";
import filterReducer from "./slices/filterSlice";
import globalStateReducer from "./slices/globalStateSlice";
import groupCategoryReducer from "./slices/groupCategories/groupCategorySlice";
import itemsReducer from "./slices/items/itemSlice";
import orderReviewReducer from "./slices/orders/orderReviewSlice";
import orderSetReducer from "./slices/orders/orderSetSlice";
import patchOrderReducer from "./slices/patchOrderSlice";
import promotionReducer from "./slices/promotions/promotionSlice";
import reportsReducer from "./slices/reports/reportSlice";
import supplierReducer from "./slices/suppliers/supplierSlice";
import territoryReducer from "./slices/territories/territorySlice";
import trackingReducer from "./slices/trackingSlice";
import currentUserReducer from "./slices/user/currentUserSlice";
import usersReducer from "./slices/user/usersSlice";
import variantCategoryReducer from "./slices/variantCategories/variantCategorySlice";

const rootReducer = combineReducers({
  channels: channelReducer,
  currentUser: currentUserReducer,
  error: errorReducer,
  filters: filterReducer,
  globalState: globalStateReducer,
  groupCategories: groupCategoryReducer,
  items: itemsReducer,
  orderReview: orderReviewReducer,
  patchOrder: patchOrderReducer,
  promotions: promotionReducer,
  reports: reportsReducer,
  suppliers: supplierReducer,
  territories: territoryReducer,
  tracking: trackingReducer,
  users: usersReducer,
  variantCategories: variantCategoryReducer,
  globalReports: globalReportReducer,
  orderSet: orderSetReducer,
});

export default rootReducer;
